export enum SenderState {
    Draft = 0,
    Sent = 1,
    Trash = 2,
    Deleted = 3,
    Inbox = 4,
}